Prism.languages.arff={comment:/%.*/,string:{pattern:/(["'])(?:\\.|(?!\1)[^\\\r\n])*\1/,greedy:!0},keyword:/@(?:attribute|data|end|relation)\b/i,number:/\b\d+(?:\.\d+)?\b/,punctuation:/[{},]/};


//////////////////
// WEBPACK FOOTER
// ./node_modules/prismjs/components/prism-arff.min.js
// module id = 1024
// module chunks = 0